import { Phone, Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: t.nav.services, href: "#tjanster" },
    { name: t.nav.fleet, href: "#bilar" },
    { name: t.nav.about, href: "#om-oss" },
    { name: t.nav.contact, href: "#kontakt" },
  ];

  return (
    <footer className="bg-[#111111] border-t border-white/5" data-testid="footer">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <span className="text-white font-bold text-lg block">Taxi Kalmar AB</span>
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed mb-6">
              {t.footer.description}
            </p>
            <p className="text-neutral-500 text-sm">
              Org.nr: 559507-9624
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t.footer.quickLinks}</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="footer-link text-sm">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t.footer.services}</h4>
            <ul className="space-y-3">
              {t.footer.servicesList.map((service) => (
                <li key={service}>
                  <span className="text-neutral-400 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6">{t.footer.contact}</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-yellow-500 mt-1 flex-shrink-0" />
                <div>
                  <a href="tel:0480474717" className="footer-link text-sm block">0480 47 47 17</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-yellow-500 mt-1 flex-shrink-0" />
                <a href="mailto:info@taxinora.se" className="footer-link text-sm">
                  info@taxinora.se
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-yellow-500 mt-1 flex-shrink-0" />
                <span className="text-neutral-400 text-sm">
                  Trädgårdsagan 12<br />
                  392 49 Kalmar
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-neutral-500 text-sm">
            © {currentYear} Taxi Kalmar AB. {t.footer.allRights}
          </p>
          <div className="flex gap-6">
            <a href="https://taxinora.se/privacypolicy.html" className="footer-link text-sm">
              {t.footer.privacyPolicy}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
